import { render } from "./TableViewBatch.vue?vue&type=template&id=14544ef6&ts=true"
import script from "./TableViewBatch.vue?vue&type=script&lang=ts"
export * from "./TableViewBatch.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__